import { convertToGMT } from '@/utils/helper'
import ReactTimeago from 'react-timeago'

interface ReactTimeAgoProps {
  date: string
}

const TimeAgoComponent = ReactTimeago as any

const CustomTimeAgo = ({ date }: ReactTimeAgoProps) => {
  const formatter = (value: number, unit: string, suffix: string) =>
    unit === 'second' ? 'just now' : `${value} ${value == 1 ? unit : `${unit}s`} ${suffix}`

  return <TimeAgoComponent date={convertToGMT(date)} formatter={formatter} />
}

export default CustomTimeAgo
